import get from 'lodash.get';

import { getRule } from 'selectors/configuration';

export default function getChannel(state) {
  const matchedRule = getRule(state.configuration);
  if (matchedRule) {
    return get(matchedRule, 'rule.channel', '');
  }

  return '';
}
